import { createSlice } from '@reduxjs/toolkit'
import { service } from '../shared/_services/api_service'
import { setLoading } from './loader';
import { errorHandler, successHandler } from '../shared/_helper/responseHelper';

const initialState = {
  teamsData: [],
  totalteams: 0,
  isOpenModal: false,
  isImageOpenModal: false,
  isPartnerOpenModal: false,
  isStatusOpenModal: false,
}

export const teamsSlice = createSlice({
  name: "teams",
  initialState,
  reducers: {
    setteamsData(state, { payload }) {
      state.teamsData = payload.result
      state.totalteams = payload.count
    },
    updateteamsData(state, { payload }) {
      const objIndex = state.teamsData.findIndex((obj) => obj._id === payload._id);
      if (objIndex >= 0) {
        state.teamsData[objIndex] = payload
      }
    },
    pushteamsData(state, { payload }) {
      state.teamsData.push(payload)
      state.totalteams = + 1
    },
    sliceTestData(state, { payload }) {
      const objIndex = state.teamsData.findIndex((obj) => obj._id === payload);
      if (objIndex >= 0) {
        state.teamsData.splice(objIndex, 1)
        state.totalteams -= 1
      }
    },

    isOpenModal(state, { payload }) {
      state.isOpenModal = payload
    },
    ModalToggle(state, { payload }) {
      state.isOpenModal = !state.isOpenModal
    },
    isImageOpenModal(state, { payload }) {
      state.isImageOpenModal = payload
    },
    ImagestatusToggle(state, { payload }) {
      state.isImageOpenModal = !state.isImageOpenModal
    },
    isPartnerOpenModal(state, { payload }) {
      state.isPartnerOpenModal = payload
    },
    PartnerstatusToggle(state, { payload }) {
      state.isPartnerOpenModal = !state.isPartnerOpenModal
    },
    isOpenStatusModal(state, { payload }) {
      state.isStatusOpenModal = payload
    },
    statusToggle(state, { payload }) {
      state.isStatusOpenModal = !state.isStatusOpenModal
    },
  }
})

export const { setteamsData, updateteamsData, pushteamsData, sliceTestData, isOpenModal, ModalToggle, isImageOpenModal, ImagestatusToggle, isPartnerOpenModal, PartnerstatusToggle, isOpenStatusModal, statusToggle } = teamsSlice.actions;

export default teamsSlice.reducer;

export function getTeams(status) {
  return async function getteamsThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.getteams(status).then(
        (response) => {
          dispatch(setLoading(false))
          dispatch(setteamsData(response.data))
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function addteams(payload) {
  return async function addteamsThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.addteams(payload).then(
        (response) => {
          dispatch(ModalToggle())
          dispatch(setLoading(false))
          dispatch(pushteamsData(response.data))
          successHandler('Added Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function updateteams(id, data) {
  return async function updateteamsThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.updateteams(id, data).then(
        (response) => {
          dispatch(ModalToggle())
          dispatch(setLoading(false))
          dispatch(updateteamsData(response.data))
          successHandler('Updated Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function updateteamsImage(id, image) {
  return async function updateteamsImageThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.updateteamsImage(id, image).then(
        (response) => {
          dispatch(ImagestatusToggle())
          dispatch(setLoading(false))
          dispatch(updateteamsData(response.data))
          successHandler('Updated Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function updatepartnerImage(id, image) {
  return async function updatepartnerImageThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.updatepartnerImage(id, image).then(
        (response) => {
          dispatch(PartnerstatusToggle())
          dispatch(setLoading(false))
          dispatch(updateteamsData(response.data))
          successHandler('Updated Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}

export function updateStatus(id, status) {
  return async function updateStatusThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.updateTeamStatus(id, status).then(
        (response) => {
          dispatch(statusToggle())
          dispatch(setLoading(false))
          dispatch(updateteamsData(response.data))
          successHandler('Updated Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}

export function deleteteams(id) {
  return async function deleteteamsImageThunk(dispatch) {
    try {
      dispatch(setLoading(true))
      await service.deleteTeam(id).then(
        (response) => {
          dispatch(sliceTestData(id))
          dispatch(setLoading(false))
          successHandler('Deleted Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}

